import React from 'react';
import { useTranslation } from 'react-i18next';
import { Row } from 'components/UI/Row';
import { Link, Box } from '@material-ui/core';
import { faInfoCircle, faMapMarked, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Info = () => {
  const { t } = useTranslation();
  return (
    <Row alignItems="flex-end">
      <Box m={2}>
        <FontAwesomeIcon icon={faInfoCircle} /> {t('home.4boxes info')}
      </Box>
      <Box m={2}>
        <FontAwesomeIcon icon={faMapMarked} /> {t('home.4boxes address')}
      </Box>
      <div style={{ display: 'flex', flex: 1 }} />
      <Box m={2}>
        <FontAwesomeIcon icon={faEnvelope} /> <Link href="mailto:contact@4boxes.io">contact@4boxes.io</Link>
      </Box>
    </Row>
  );
};

export { Info };
